import React from "react";
import { X, Warning } from "@phosphor-icons/react";

/**
 * Modal de confirmación estilizado que reemplaza window.confirm().
 *
 * Uso: control externo abierto vía estado.
 *   const [confirm, setConfirm] = useState(null);
 *   ...
 *   <ConfirmDialog
 *     open={!!confirm}
 *     title="Eliminar?"
 *     body="Esta acción no se puede deshacer."
 *     confirmLabel="Eliminar"
 *     danger
 *     onConfirm={() => { confirm.action(); setConfirm(null); }}
 *     onCancel={() => setConfirm(null)}
 *   />
 */
export default function ConfirmDialog({
  open,
  title = "Confirmar",
  body = "¿Estás seguro?",
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  danger = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
      data-testid="confirm-dialog"
      onClick={(e) => { if (e.target === e.currentTarget) onCancel?.(); }}
    >
      <div className="card-base p-6 w-full max-w-md">
        <div className="flex items-start gap-3 mb-3">
          {danger ? (
            <Warning size={28} weight="duotone" className="text-[#FF3B30] flex-shrink-0" />
          ) : null}
          <div className="flex-1">
            <h3 className="font-display font-black uppercase text-xl tracking-tight">{title}</h3>
          </div>
          <button
            onClick={onCancel}
            className="text-muted hover:text-white"
            data-testid="confirm-dialog-close"
            aria-label="Cerrar"
          >
            <X size={18} weight="bold" />
          </button>
        </div>
        {body && (
          <p className="text-sm text-muted mb-6 leading-relaxed whitespace-pre-line">{body}</p>
        )}
        <div className="flex gap-3 justify-end">
          <button onClick={onCancel} className="btn-secondary" data-testid="confirm-dialog-cancel">
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={danger ? "btn-primary !bg-[#FF3B30] !border-[#FF3B30] hover:!bg-[#cc2e26]" : "btn-primary"}
            data-testid="confirm-dialog-accept"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
